<header [class.has-bubbles]="!store.currentQuestion()">
  <h1 class="pr-u-mask">La Quête des Luccasiens</h1>
  @if (store.hasStarted()) {
    <p class="pr-u-h3 header-score">Score {{ store.score() }} / {{ store.principles().size }}</p>
    <img src="assets/icons/icon-lucca.png" height="40" width="40" alt="" />
  }
</header>
